import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

export const loadGlobalCopilotDrawer = () =>
  import(/* webpackChunkName: "4-feat-global-copilot-drawer" */ './GlobalCopilotDrawer');

const GlobalCopilotDrawerLoader = async () => {
  const { GlobalCopilotDrawer } = await loadGlobalCopilotDrawer();

  return { default: GlobalCopilotDrawer };
};

export const LoadableGlobalCopilotDrawer = lazyLoadOnRender({
  loader: GlobalCopilotDrawerLoader,
});
